import { resolveBackendUrl } from './desktopBootstrap';

// Shop location for route starting point
export const SHOP_LOCATION = {
  lat: 36.1588,
  lng: -115.1617,
  address: "1815 W. Charleston Blvd, Ste. 6, Las Vegas, NV 89102"
};

// API configuration
// Installed desktop pages must never silently use the browser build's cloud URL
// when their privileged preload bridge is absent. The entry point also blocks
// rendering in that state; this boundary protects early module consumers.
export const BACKEND_URL = resolveBackendUrl(
  typeof window !== 'undefined' ? window.location.protocol : null,
  typeof window !== 'undefined' ? window.lvbDesktop : null,
  process.env.REACT_APP_BACKEND_URL,
);
// An unconfigured browser build can still use same-origin /api paths. Null is
// reserved for an installed desktop whose preload bridge did not initialize.
export const API = BACKEND_URL === null ? null : `${BACKEND_URL || ''}/api`;
// The REACT_APP_ prefix is what compiles this into the browser bundle, which is
// why only the browser key may carry it. The backend's key is GOOGAPI_BACK and
// must never gain that prefix. See TCA-26082302.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGAPI_FRONT;

// Desktop installer offered for download from Settings → Devices. The installer
// is too large for Cloudflare Pages, so host it externally (e.g. a public R2
// object) and set the URL here. Empty = no download offered yet.
export const DESKTOP_INSTALLER_URL = process.env.REACT_APP_DESKTOP_INSTALLER_URL || '';

// Predefined network sources (alphabetical, with Other last)
export const NETWORK_SOURCES = ['Bloomnet', 'FTD', 'JustFlowers', 'LVB', 'Teleflora', 'Other'];

// Default map center (Las Vegas)
export const DEFAULT_MAP_CENTER = {
  lat: 36.1699,
  lng: -115.1398
};

export const DEFAULT_MAP_ZOOM = 11;

// Exact by definition: a statute mile is 1609.344 metres. It was written as
// 1609.34 in three route-distance calculations and correctly elsewhere.
// See TCA-26081301.
export const METERS_PER_MILE = 1609.344;
